import React, { useState, useEffect } from 'react'
// import { useLocation } from 'react-router-dom'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import { getAttendanceSchemaMulti } from '../../../redux/actions/multiReview'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import AttendanceRecordForm from '../../../widgets/attendanceRecord/AttendanceRecordWidget'

export default function AttendanceRecord(props) {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const [schema, setSchema] = useState()

  useEffect(() => {
    let idList = sessionStorage.getItem('mutiReview')

    const request = {
      id: idList,
    }

    handleGetSchema(request)
  }, [])

  const handleGetSchema = async (request) => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getAttendanceSchemaMulti(request)
      setSchema(response)
    } catch (e) {
      console.log('e', e)
      setError({})
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isMultiReview>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isMultiReview>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal isMultiReview>
      <ContentHeader header={schema.header} subHeader={schema.subHeader} />

      {schema?.forms?.expertList && (
        <>
          <AttendanceRecordForm schema={schema.forms.expertList} />
          <br />
        </>
      )}
    </SidebarProposal>
  )
}
